// FILE GENERATED BY IMPORT/INDEX.MJS - CHANGES WILL LIKELY BE OVERWRITTEN
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react'

function Venue15(props) {
    return (
        <svg
            id="_x31_5"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 250 250"
            style={{
                enableBackground: 'new 0 0 250 250',
            }}
            xmlSpace="preserve"
            {...props}
        >
            <style type="text/css">
                {
                    "\n\t.st0{fill:#5B5B5B;}\n\t.st1{fill:#7F7F7F;}\n\t.st2{fill:#FFEC5F;}\n\t.st3{fill:#68836A;}\n\t.st4{font-family:'ArialMT';}\n\t.st5{font-size:11px;}\n\t.st6{fill:#A88B49;}\n\t.st7{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:0.75;}\n\t.st9{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4;}\n\t.st10{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:4.0018;}\n"
                }
            </style>
            <g id="ARI">
                <g id="compass">
                    <path
                        className="st0"
                        d="M226.8,208.5l-1.4-9.1l1.6-7.8l1.6,7.8L226.8,208.5z"
                    />
                    <path
                        className="st1"
                        d="M227,215c-8.6,0-15.5-7-15.5-15.5c0-8.6,7-15.5,15.5-15.5c8.6,0,15.5,7,15.5,15.5 C242.5,208.1,235.5,215,227,215z M227,185.3c-7.8,0-14.2,6.3-14.2,14.2c0,7.8,6.3,14.2,14.2,14.2c7.8,0,14.2-6.3,14.2-14.2 C241.2,191.7,234.9,185.3,227,185.3z"
                    />
                    <path
                        className="st0"
                        d="M229.1,197.4c1.2,1.2,1.2,3,0,4.2s-3,1.2-4.2,0s-1.2-3,0-4.2C226.1,196.3,228,196.3,229.1,197.4z  M225.8,190.2v-3.1h0.5l1.4,2.1v-2.1h0.5v3.1h-0.5l-1.4-2.1v2.1H225.8z"
                    />
                    <path
                        className="st2"
                        d="M228.2,198.4c0.6,0.6,0.6,1.7,0,2.3s-1.7,0.6-2.3,0s-0.6-1.7,0-2.3C226.5,197.7,227.5,197.7,228.2,198.4z"
                    />
                </g>
                <g id="distances">
                    <text
                        transform="matrix(1 0 0 1 6.9824 117.9487)"
                        className="st3 st4 st5"
                    >
                        330
                    </text>
                    <text
                        transform="matrix(1 0 0 1 43.75 60.9282)"
                        className="st3 st4 st5"
                    >
                        368
                    </text>
                    <text
                        transform="matrix(1 0 0 1 72.6675 34.1655)"
                        className="st3 st4 st5"
                    >
                        413
                    </text>
                    <text
                        transform="matrix(1 0 0 1 156.168 34.2153)"
                        className="st3 st4 st5"
                    >
                        413
                    </text>
                    <text
                        transform="matrix(1 0 0 1 120.2983 30.564)"
                        className="st3 st4 st5"
                    >
                        407
                    </text>
                    <text
                        transform="matrix(1 0 0 1 179.1035 52.6802)"
                        className="st3 st4 st5"
                    >
                        376
                    </text>
                    <text
                        transform="matrix(1 0 0 1 226.0488 108.4307)"
                        className="st3 st4 st5"
                    >
                        335
                    </text>
                </g>
                <g id="field">
                    <path
                        id="Outfield_1_"
                        className="st6"
                        d="M223.2,105l-0.5,1.8l-1.4,2.2v7.4h-0.8L202.7,135l-22.8,39.3c0,0-41.1,45.9-45.7,48.1 c-1.6,1-3,2.9-8.8,2.9c-5.1,0-8-1.9-9.9-2.9c-4.2-2.1-43.2-47-43.2-47l-23.8-40.3L30,115.7h-2l-0.1-9.6V95.3l-0.1-3.9l-0.1-4.1 l2.9-0.7h3.3l2-1.6l1.9-1.7l1.9-1.7l1.9-1.8l2-1.8l2-1.8l2-1.8l2-1.8l2-1.8l2-1.8l2-1.8l2.1-1.9l2.1-1.9l2.1-1.9l2.1-1.9l2.2-1.9 l2.2-2l2.2-2l2.2-2l2.3-2l2.3-2.1l2.3-2.1l2.4-2.2l2.4-2.2l2.5-2.2l2.5-2.3l2.7-1.7l2.9-0.6l3-0.5h21l3,0.8h5.8l3-0.8h21l2.8,1.1 h3l2.7,1.9l2.5,2.3l2.5,2.2l2.4,2.2l2.4,2.1l2.3,2.1l2.3,2.1l2.3,2l2.2,2l2.2,2l2.2,2l2.2,1.9l2.2,1.7l2.1,1.9l2.1,1.9l2.1,1.9 l2,1.8l2,1.8l2,1.8l2,1.8l2,1.8l2,1.8l2,1.8l1.9,1.8l1.9,1.7l1.9,1.7l1.9,1.7l1.9,1.7l3.1,0.3l2.1,1.5v11.3L223.2,105L223.2,105z"
                    />
                    <path
                        id="grass_1_"
                        className="st3"
                        d="M125.7,220.2c-3.1,0-6.3-1.6-7.4-2.2c-3.8-2.9-23.2-24.2-40.5-42.8l-22.9-41.9L36,114.4v-11.8 l0.8-8l4.3-3.6l53.4-48l4.3-1.1h51.6l4.8,1.1l0.2,0.1l59.2,53.1v16.5l-17.2,18.4l-22.9,39.4c-16.6,18.5-38.8,44.7-42.8,47.7 C131.7,218.3,129.3,220.2,125.7,220.2z"
                    />
                    <path
                        id="infield_sand"
                        className="st6"
                        d="M131.9,202.4c0-1.1-0.3-2.1-0.7-3l32.7-32.7l-1-1c-5-16-20-27.7-37.7-27.7 s-32.7,11.7-37.7,27.7l-1,1l32.7,32.7c-0.5,0.9-0.7,1.9-0.7,3c0,0.3,0,0.5,0,0.8l-12.6,2.5l7.2,8l6.7-7.4c1.2,1.7,3.2,2.8,5.4,2.8 s4.2-1.1,5.4-2.8l6.7,7.4l7.2-8l-12.6-2.5C131.9,202.9,131.9,202.7,131.9,202.4z M125.2,195.7c-1.6,0-3.2,0.6-4.3,1.6l-17.7-17.7 l2.5-2.5c1.6-1.5,1.6-4,0-5.6l16.8-16.8c0.8,0.5,1.7,0.8,2.7,0.8s1.9-0.3,2.7-0.8l16.8,16.8c-1.6,1.6-1.6,4.1,0,5.6l2.5,2.5 l-17.7,17.7C128.4,196.3,126.8,195.7,125.2,195.7z"
                    />
                </g>
                <g id="persistent_1_">
                    <g id="mound_1_">
                        <path
                            id="pitching-mound_1_"
                            className="st6"
                            d="M122.5,174.7c-1.5,1.5-1.5,3.9,0,5.4s3.9,1.5,5.4,0c1.5-1.5,1.5-3.9,0-5.4 C126.5,173.2,124,173.2,122.5,174.7z"
                        />
                        <path
                            id="pitching-rubber_1_"
                            className="st7"
                            d="M123.2,176.6h4v1.6h-4V176.6z"
                        />
                    </g>
                    <g id="lines_1_">
                        <path
                            id="left-foul-line_1_"
                            className="st8"
                            d="M125.2,203.2L28,106.1"
                        />
                        <path
                            id="right-foul-line_1_"
                            className="st8"
                            d="M125.2,203.2l98.1-98.1"
                        />
                    </g>
                    <g id="bases_2_">
                        <rect
                            id="third-base_2_"
                            x={99.2}
                            y={175.1}
                            transform="matrix(0.7073 -0.7069 0.7069 0.7073 -95.3473 122.8833)"
                            className="st9"
                            width={3}
                            height={3}
                        />
                        <rect
                            id="first-base_2_"
                            x={148.1}
                            y={175.2}
                            transform="matrix(0.7073 -0.7069 0.7069 0.7073 -81.1078 157.4629)"
                            className="st9"
                            width={3}
                            height={3}
                        />
                        <rect
                            id="second-base_2_"
                            x={123.7}
                            y={148.6}
                            transform="matrix(0.707 -0.7073 0.7073 0.707 -69.4796 132.5406)"
                            className="st10"
                            width={3}
                            height={3}
                        />
                        <polygon
                            id="home_2_"
                            className="st7"
                            points="126.7,201.8 125.2,203.4 123.7,201.8 123.7,200.3 126.7,200.3  "
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}
export default Venue15
